import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '讲好中国故事';

const route: RouteConfig = {
  path: '/20220927ZGGS',
  name: 'STORY',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
    rank: 1,
  },
  children: [
    {
      path: 'News',
      component: () => import('./News.vue'),
      name: 'STORYNews',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Enroll',
      component: () => import('./Enroll.vue'),
      name: 'STORYEnroll',
      meta: {
        title: PAGE_TITLE,
      },
    },
    // {
    //   path: 'List',
    //   component: () => import('./List.vue'),
    //   name: 'STORYList',
    //   meta: {
    //     title: PAGE_TITLE,
    //   },
    // },
    // {
    //   path: 'Detail',
    //   component: () => import('./Detail.vue'),
    //   name: 'GLGXDetail',
    //   meta: {
    //     title: PAGE_TITLE,
    //     rank: 3,
    //   },
    // },
    // {
    //   path: 'News',
    //   component: () => import('./News.vue'),
    //   name: 'GLGXNews',
    //   meta: {
    //     title: PAGE_TITLE,
    //     rank: 4,
    //   },
    // },
    // {
    //   path: 'Two',
    //   component: () => import('./Two.vue'),
    //   name: 'GLGXTwo',
    //   meta: {
    //     title: PAGE_TITLE,
    //     rank: 3,
    //   },
    // },
  ],
};

export default route;
